if (!customElements.get('kenra-shop-at')) {
  customElements.define(
    'kenra-shop-at',
    class KenraShopAt extends HTMLElement {
      constructor() {
        super();
        this.variantChangeUnsubscriber = null;
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      onVariantChange(event) {
        var data = event.data;
        if (!data) return;
        // Ignore events from other product sections on the page.
        if (this.sectionId && data.sectionId && String(data.sectionId) !== String(this.sectionId)) return;

        this.showVariant(data.variant && data.variant.id);
      }

      showVariant(variantId) {
        var blocks = this.querySelectorAll('[data-shop-at-variant]');
        blocks.forEach(function (block) {
          var isMatch = String(block.getAttribute('data-shop-at-variant')) === String(variantId);
          block.hidden = !isMatch;
        });
      }
    },
  );
}
